import { 
  CogIcon, 
  WrenchScrewdriverIcon, 
  ShieldCheckIcon, 
  ChartBarIcon, 
  DocumentTextIcon,
  LightBulbIcon,
  RocketLaunchIcon,
  CpuChipIcon,
  ServerIcon,
  CloudIcon,
  BoltIcon,
  FireIcon,
  StarIcon,
  BeakerIcon,
  CubeIcon,
  PuzzlePieceIcon,
  CommandLineIcon,
  CircleStackIcon,
  ClipboardDocumentCheckIcon,
  CheckBadgeIcon,
  AcademicCapIcon,
  BuildingOfficeIcon,
  UserGroupIcon,
  GlobeAltIcon,
  ChartPieIcon
} from '@heroicons/react/24/solid';

/**
 * All available icons for slides - 25 diverse icons for various business/tech contexts
 */
export const ALL_SLIDE_ICONS = [
  CogIcon,                      // 1. Settings/Configuration
  WrenchScrewdriverIcon,        // 2. Maintenance/Tools
  ShieldCheckIcon,              // 3. Security/Safety
  ChartBarIcon,                 // 4. Analytics/Metrics
  DocumentTextIcon,             // 5. Documentation/Reports
  LightBulbIcon,                // 6. Ideas/Innovation
  RocketLaunchIcon,             // 7. Launch/Growth
  CpuChipIcon,                  // 8. Technology/Processing
  ServerIcon,                   // 9. Infrastructure/Systems
  CloudIcon,                    // 10. Cloud/Storage
  BoltIcon,                     // 11. Performance/Speed
  FireIcon,                     // 12. Hot/Priority
  StarIcon,                     // 13. Excellence/Featured
  BeakerIcon,                   // 14. Experimentation/Research
  CubeIcon,                     // 15. Building Blocks/Modules
  PuzzlePieceIcon,              // 16. Integration/Components
  CommandLineIcon,              // 17. Development/Code
  CircleStackIcon,              // 18. Database/Data
  ClipboardDocumentCheckIcon,   // 19. Checklist/Compliance
  CheckBadgeIcon,               // 20. Verification/Quality
  AcademicCapIcon,              // 21. Training/Education
  BuildingOfficeIcon,           // 22. Organization/Enterprise
  UserGroupIcon,                // 23. Team/Collaboration
  GlobeAltIcon,                 // 24. Global/Network
  ChartPieIcon                  // 25. Business Intelligence/Insights
];

/**
 * Shuffle array using Fisher-Yates algorithm
 * @param {Array} array - Array to shuffle
 * @returns {Array} - Shuffled array
 */
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/**
 * Get shuffled icons for slides
 * @returns {Array} - Shuffled array of icon components
 */
export const getShuffledIcons = () => shuffleArray(ALL_SLIDE_ICONS);

